import DiscountSummary from './DiscountSummary';
import IntrinsicModel from './IntrinsicModel';

export interface IntrinsicValueSummaryProps {
  uniqueSymbol: string;
  reportingCurrencyISO: string;
  reportingCurrencySymbol: string;
  primaryTradingCurrecyISO: string;
  primaryTradingCurrencySymbol: string;
  tradingItemCurrencyISO: string;
  tradingItemCurrencySymbol: string;
  companyShortName: string;
  exchangeSymbol: string;
  tickerSymbol: string;
  listingPrice: number;
  relativeListingSharesOutstanding: number;
  model: string;
  riskFreeRate: number;
  costOfEquity: number;
  adrPerShare: number;
  pv5y: number;
  terminalValue: number;
  pvtv: number;
  npv: number;
  npvPerShare: number;
  npvPerShareReportedCurrency?: number;
  intrinsicDiscount: number;
  primaryListingExchangeSymbol: string;
  primaryListingTickerSymbol: string;

  REIT?: {
    NAV: number;
    NAVCount: number;
  };

  dividendDiscount?: {
    DPS: number;
    payout: number;
    ROE: number;
    expectedGrowth: number;
    DDMGrowth: number;
    DDMSource: string;
  };

  twoStagefcf?: {
    affoEstimates?: number;
    growthCAGR5y: number;
    scale: string;
    scaleNumeric: number;
    sharesOutstanding: number;
    fcfsource?: string;
    fcfData: { date: number; value: number }[];
    fcfCount: { date: number; value: number }[];
    fcfLtm: number;
    firstStage: {
      year: number;
      data: number;
      source: string;
      discounted: number;
    }[];
  };

  excessReturns?: {
    stableBookValue: number;
    returnOnEquityAvg: number;
    stableEPS: number;
    stableEPSSource: string;
    stableBookValueSource: string;
    bookValue: number;
    equityCost: number;
    excessReturn: number;
  };
}

const IntrinsicValueSummary = ({
  uniqueSymbol,
  reportingCurrencyISO,
  reportingCurrencySymbol,
  primaryTradingCurrecyISO,
  primaryTradingCurrencySymbol,
  tradingItemCurrencyISO,
  tradingItemCurrencySymbol,
  companyShortName,
  exchangeSymbol,
  tickerSymbol,
  listingPrice,
  relativeListingSharesOutstanding,
  model,
  riskFreeRate,
  costOfEquity,
  adrPerShare,
  pv5y,
  terminalValue,
  pvtv,
  npv,
  npvPerShare,
  npvPerShareReportedCurrency,
  intrinsicDiscount,
  REIT,
  dividendDiscount,
  twoStagefcf,
  excessReturns,
  primaryListingExchangeSymbol,
  primaryListingTickerSymbol,
}: IntrinsicValueSummaryProps) => (
  <div>
    <p>
      <strong>
        Discounted Cash Flow Calculation for {uniqueSymbol} using {model}
      </strong>
    </p>
    <IntrinsicModel
      uniqueSymbol={uniqueSymbol}
      reportingCurrencyISO={reportingCurrencyISO}
      reportingCurrencySymbol={reportingCurrencySymbol}
      companyShortName={companyShortName}
      relativeListingSharesOutstanding={relativeListingSharesOutstanding}
      riskFreeRate={riskFreeRate}
      costOfEquity={costOfEquity}
      pv5y={pv5y}
      terminalValue={terminalValue}
      pvtv={pvtv}
      npv={npv}
      npvPerShare={npvPerShare}
      npvPerShareReportedCurrency={npvPerShareReportedCurrency}
      REIT={REIT}
      dividendDiscount={dividendDiscount}
      twoStagefcf={twoStagefcf}
      excessReturns={excessReturns}
      model={model}
    />
    <DiscountSummary
      uniqueSymbol={uniqueSymbol}
      reportingCurrencyISO={reportingCurrencyISO}
      reportingCurrencySymbol={reportingCurrencySymbol}
      primaryTradingCurrecyISO={primaryTradingCurrecyISO}
      primaryTradingCurrencySymbol={primaryTradingCurrencySymbol}
      tradingItemCurrencyISO={tradingItemCurrencyISO}
      tradingItemCurrencySymbol={tradingItemCurrencySymbol}
      exchangeSymbol={exchangeSymbol}
      tickerSymbol={tickerSymbol}
      listingPrice={listingPrice}
      adrPerShare={adrPerShare}
      npv={npv}
      npvPerShare={npvPerShare}
      npvPerShareReportedCurrency={npvPerShareReportedCurrency}
      intrinsicDiscount={intrinsicDiscount}
      relativeListingSharesOutstanding={relativeListingSharesOutstanding}
      primaryListingExchangeSymbol={primaryListingExchangeSymbol}
      primaryListingTickerSymbol={primaryListingTickerSymbol}
    />
  </div>
);

export default IntrinsicValueSummary;
